import React, {
  useState,
} from 'react';

import {
  Tooltip,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

interface Item {
  id: number
  name: string
  tooltip: string
}
interface Props {
  tabs: Item[]
  children: { (activeTab: number): void }
}

const Tab = ({ tabs, children }: Props) => {
  const [activeTab, setTab] = useState(1);

  return (
    <Flex column width="100%">
      <S.Header>
        {tabs.map(tab => (tab.tooltip
          ? (
            <Tooltip
              key={tab.id}
              body={tab.tooltip}
              positions={['top']}
            >
              <S.Tab
                active={tab.id === activeTab}
                onClick={() => setTab(tab.id)}
              >
                {tab.name}
              </S.Tab>
            </Tooltip>
          ) : (
            <S.Tab
              key={tab.id}
              active={tab.id === activeTab}
              onClick={() => setTab(tab.id)}
            >
              {tab.name}
            </S.Tab>
          )))}
      </S.Header>
      <S.Content>
        {children(activeTab)}
      </S.Content>
    </Flex>
  );
};

export default Tab;
